import gql from 'graphql-tag';

export const GET_SUBSCRIBE_ALERT = gql`
  query alertSystem_getSubscribed {
    alertSystem_getSubscribed {
      username
      email
      isEmailVerified
      isAlertWhatsapp
      phoneNumber
      __typename
    }
  }
`;

export const GET_AUTO_ALERT = gql`
  query alertSystem_getAutoAlert($projectId: Id!, $limit: Int!, $page: Int!) {
    alertSystem_getAutoAlert(
      projectId: $projectId
      limit: $limit
      page: $page
    ) {
      result {
        id
        alertName
        createdAt
        isWatching
        streamType
        socialMedia
        isHashtag
        threshold
        progress
        lastAlert
        category
      }
      totalRows
      totalPages
      page
      limit
      __typename
    }
  }
`;

export const GET_MANUAL_ALERT = gql`
  query alertSystem_getManualAlert($projectId: Id!, $limit: Int!, $page: Int!) {
    alertSystem_getManualAlert(
      projectId: $projectId
      limit: $limit
      page: $page
    ) {
      result {
        id
        alertName
        createdAt
        phrases
        threshold
        isWatching
        lastAlert
        category
        objectGroupId
        excludeFromUsername
        sentiment
        validationList
        postOwnership
        thresholdType
      }
      totalRows
      totalPages
      page
      limit
      __typename
    }
  }
`;

export const GET_MANUAL_ALERT_BY_ID = gql`
  query alertSystem_getManualAlertById(
    $projectId: Id!
    $limit: Int!
    $page: Int!
  ) {
    alertSystem_getManualAlertById(
      projectId: $projectId
      limit: $limit
      page: $page
    ) {
      alertName
      createdAt
      phrases
      threshold
      isWatching
      lastAlert
      category
      objectGroupId
      excludeFromUsername
      sentiment
      validationList
      postOwnership
    }
  }
`;

export const GET_MANUAL_ALERT_ONM = gql`
  query alertSystemNews_getAlertManual(
    $projectId: Id!
    $alertName: String!
    $page: Int!
    $limit: Int!
    $categoryAlert: CategoryAlert!
  ) {
    alertSystemNews_getAlertManual(
      projectId: $projectId
      alertName: $alertName
      page: $page
      limit: $limit
      categoryAlert: $categoryAlert
    ) {
      limit
      page
      totalPages
      totalRows
      result {
        alertName
        categoryAlert
        clippingList {
          id
          name
          createdAt
          phrases
          startDate
        }
        createdAt
        id
        lastAlert
        mediaList
        phrases
        sentimentList
        threshold
        validationList
        thresholdType
        isWatching
      }
    }
  }
`;

export const GET_MANUAL_ALERT_BY_ID_V2 = gql`
  query AlertSystem_getAlertManualById($alertSettingId: Id!) {
    alertSystem_getAlertManualById(alertSettingId: $alertSettingId) {
      id
      alertName
      createdAt
      lastAlert
      objectGroupId
      phrases
      sentiment
      validationList
      postOwnership
      excludeFromUsername
      threshold
      category
      isWatching
      streamType
      socialMedia
      isHashtag
      thresholdType
      alertStart
    }
  }
`;

export const GET_MANUAL_ALERT_ONM_BY_ID = gql`
  query AlertSystemNews_getAlertManualById($alertSettingNewsId: Id!) {
    alertSystemNews_getAlertManualById(
      alertSettingNewsId: $alertSettingNewsId
    ) {
      id
      alertName
      createdAt
      lastAlert
      phrases
      threshold
      categoryAlert
      sentimentList
      clippingList {
        id
        name
        createdAt
        phrases
        startingDate
        startDate
        excludePhrases
      }
      validationList
      mediaList
      isWatching
      thresholdType
      alertStart
    }
  }
`;

export const GET_SUBSCRIBE_ALERT_REPORT = gql`
  query alertSystem_getSubscribedDailyReport {
    alertSystem_getSubscribedDailyReport {
      username
      email
      isActive
      isVerified
      phoneNumber
    }
  }
`;

export const GET_WHATSAPP_ALERT_DETAIL = gql`
  query alertSystem_getWhatsappAlertDetailById($id: Id!, $category: String!) {
    alertSystem_getWhatsappAlertDetailById(id: $id, category: $category)
  }
`;

export const GET_WHATSAPP_REPORT = gql`
  query whatsappReport_report($id: Id!) {
    whatsappReport_report(id: $id) {
      content
      projectName
    }
  }
`;
